import { Button, CircularProgress, Flex, Td, Text, Tr } from '@chakra-ui/react';

import { CustomIcon } from '../../icon';

export type DocumentTableRowUploadViewEntity = {
  fileNameWithoutExtension: string;
  isValid: boolean;
  uploadAborted: boolean;
  uploadSuccess: boolean;
  uploadStarted: boolean;
};

type Props = {
  documentUploadEntity: DocumentTableRowUploadViewEntity;
  errorMessage: string;
  progress: number;
  isPendingUploadDocument: boolean;
  abortLabel: string;
  removeLabel: string;
  onAbort: VoidFunction;
  onRemove: VoidFunction;
};

export const DocumentTableRowUploadView = ({
  documentUploadEntity,
  errorMessage,
  progress,
  isPendingUploadDocument,
  abortLabel,
  removeLabel,
  onAbort,
  onRemove,
}: Props) => {
  const hasError = errorMessage.length > 0;
  let icon = <CircularProgress color='primary500' size='28px' isIndeterminate />;

  if (!documentUploadEntity.isValid || documentUploadEntity.uploadAborted || hasError) {
    icon = <CustomIcon name='frown' color='secondary200' secondaryColor='secondary400' />;
  } else if (documentUploadEntity.uploadSuccess) {
    icon = <CustomIcon name='check' color='primary500' secondaryColor='primary300' />;
  }

  return (
    <Tr>
      <Td px={0}>
        <Flex alignItems='center'>
          <Flex shrink={0}>
            {isPendingUploadDocument ? (
              <CircularProgress color='primary500' value={progress} size='28px' />
            ) : (
              icon
            )}
          </Flex>
          <Flex direction='column' ml={3}>
            <Text
              variant='tableHead'
              noOfLines={1}
              wordBreak='break-word'
              color={hasError ? 'secondary400' : 'neutral500'}>
              {documentUploadEntity.fileNameWithoutExtension}
            </Text>
            {hasError ? (
              <Text variant='small' fontWeight='semibold' color='secondary400'>
                {errorMessage}
              </Text>
            ) : null}
          </Flex>
        </Flex>
      </Td>
      <Td paddingInlineEnd={0} textAlign='right'>
        {!hasError &&
          documentUploadEntity.uploadStarted &&
          !documentUploadEntity.uploadSuccess &&
          !documentUploadEntity.uploadAborted && (
            <Button
              variant='unstyled'
              role='button'
              onClick={onAbort}
              borderColor='primary400'
              title={abortLabel}>
              <Text variant='tableHead' color='primary500'>
                {abortLabel}
              </Text>
            </Button>
          )}
        {hasError ? (
          <Button
            variant='unstyled'
            role='button'
            onClick={onRemove}
            borderColor='secondary400'
            title={removeLabel}>
            <Text variant='tableHead' color='secondary500'>
              {removeLabel}
            </Text>
          </Button>
        ) : null}
      </Td>
    </Tr>
  );
};
